// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressOptionalRequest } from './address-optional-request';

// @ts-ignore
import { PatientBasicInformationRequest } from './patient-basic-information-request';

// @ts-ignore
import { PatientCommunicationPreferencesRequest } from './patient-communication-preferences-request';

// @ts-ignore
import { PatientOtherInformationRequest } from './patient-other-information-request';

// @ts-ignore
import { PatientPhoneInformationRequest } from './patient-phone-information-request';

/** See com.rev360.pms.api.controller.patient.QuickAddPatientRequest */
/* istanbul ignore next */
@GandalfModel
export class QuickAddPatientRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Address is Required' } })
	@GandalfProperty({ designType: AddressOptionalRequest, isRequired: true })
	address!: AddressOptionalRequest;

	@GandalfValidator({ notNull: { message: 'Basic Information is required' } })
	@GandalfProperty({ designType: PatientBasicInformationRequest, isRequired: true })
	patientBasicInformation!: PatientBasicInformationRequest;

	@GandalfValidator({ notNull: { message: 'Communication Preferences is Required' } })
	@GandalfProperty({ designType: PatientCommunicationPreferencesRequest, isRequired: true })
	patientCommunicationPreferences!: PatientCommunicationPreferencesRequest;

	@GandalfValidator({ notNull: { message: 'Other Information is Required' } })
	@GandalfProperty({ designType: PatientOtherInformationRequest, isRequired: true })
	patientOtherInformation!: PatientOtherInformationRequest;

	@GandalfValidator({ notNull: { message: 'Phone Information is Required' } })
	@GandalfProperty({ designType: PatientPhoneInformationRequest, isRequired: true })
	patientPhoneInformation!: PatientPhoneInformationRequest;

}
